import axios from 'axios';

// Use relative URL when accessed via domain, otherwise use environment variable
const API_BASE_URL = window.location.hostname === 'admin.binsandbags.co.uk' 
  ? '/api'  // Use relative path when on the domain (will use same protocol)
  : (process.env.REACT_APP_API_URL || 'http://localhost:8888/api');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    // Check both localStorage (remember me) and sessionStorage
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if this is a login attempt (the login endpoint returns 401 for invalid credentials)
      const isLoginAttempt = error.config?.url?.includes('/auth/login');
      
      if (!isLoginAttempt) {
        // Only clear tokens and redirect for non-login 401 errors (e.g., expired token)
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;